module.exports = __webpack_public_path__ + "static/media/intro-bg-mob.4e9ade77.svg";